import request from '@/utils/request'

// POST /api/fieldInfo/qryMachInfo 查询商户信息
export function qryMachInfo(params) {
  return request({
    url: '/api/fieldInfo/qryMachInfo',
    method: 'post',
    params
  })
}
// POST /api/fieldInfo/addMachInfo 添加商户信息
export function addMachInfo(data) {
  return request({
    url: '/api/fieldInfo/addMachInfo',
    method: 'post',
    data
  })
}
// POST /api/fieldInfo/editMachInfo 编辑商户信息
export function editMachInfo(data) {
  return request({
    url: '/api/fieldInfo/editMachInfo',
    method: 'post',
    data
  })
}
// POST /api/fieldInfo/updateMachState 更新商户信息状态
export function updateMachState(params) {
  return request({
    url: '/api/fieldInfo/updateMachState',
    method: 'post',
    params
  })
}
